import PushNotificationsService from '../services/PushNotificationsService';

const PushNotificationsActions = {

    async getPreference (user) {
        const preference = await PushNotificationsService.checkPushNotificationPreference(user);
        return preference;
    },

};

export default PushNotificationsActions;



// WEBPACK FOOTER //
// ./src/actions/PushNotificationActions.js